import { ApiBase } from '../api.js';
import {
	ChangePasswordResponse,
	CreateUserRequest,
	UpdateUserDetailsRequest,
	User,
	UserLicensorsResponse,
	UserParameters,
	UserResponse
} from '../types/api/user.js';

export class ApiUsers extends ApiBase {
	async create(data: CreateUserRequest): Promise<User> {
		const result = await this.api.post('/users', data);
		return result.data;
	}

	async read(data: UserParameters): Promise<UserResponse> {
		const result = await this.api.get('/users', {
			params: {
				page: data.page,
				size: data.size,
				includeBrands: data.includeBrands,
				licensor_id: data.licensor_id
			}
		});
		return result.data;
	}

	async readOne(userId: string): Promise<User> {
		const result = await this.api.get(`/users/${ userId }`);
		return result.data;
	}

	async update(userId: string, data: Partial<User>): Promise<User> {
		const result = await this.api.put(`/users/${ userId }`, data);
		return result.data;
	}

	async delete(data: unknown): Promise<unknown> {
		const result = await this.api.delete('/users', data);
		return result.data;
	}

	async invalidateUser(userId: string): Promise<unknown> {
		const result = await this.api.get(`/users/${ userId }/invalidate-user`);
		return result.data;
	}

	async getUserDetails(userId: string): Promise<User> {
		const result = await this.api.get(`/users/details/${ userId }`);
		return result.data;
	}

	async updateUserDetails(userId: string, data: UpdateUserDetailsRequest): Promise<User> {
		const result = await this.api.put(`/users/details/${ userId }`, data);
		return result.data;
	}

	async disableUser(userId: string): Promise<{ message: string; user_id: string; }> {
		const result = await this.api.put(`/users/disable/${ userId }`);
		return result.data;
	}

	async activateUser(userId: string): Promise<{ message: string; user_id: string; }> {
		const result = await this.api.put(`/users/activate/${ userId }`);
		return result.data;
	}

	async changePassword(userId: string, data: { password: string; }): Promise<ChangePasswordResponse> {
		const result = await this.api.put(`/users/change-password/${ userId }`, data);
		return result.data;
	}

	async getUserLicensors(userId: string): Promise<UserLicensorsResponse> {
		const result = await this.api.get(`/users/licensors/${ userId }`);
		return result.data;
	}

	async updateBrandAccess(userId: string, brandIds: string[], active: boolean): Promise<unknown> {
		const result = await this.api.put(`/users/brand-access/${ userId }`, { active, brandIds });
		return result.data;
	}

	async updateUserSetting(userId: string, key: string, value: any): Promise<{ message: string; key: string; value: any; }> {
		const result = await this.api.put(`/users/${userId}/setting`, { key, value });
		return result.data;
	}
}
